import fourthLineVoice from "../../assets/4th_line_voice.jpg";
import fiveForFighting from "../../assets/five_for_fighting.jpg";

const friends = [
  {
    name: "4th Line Voice",
    image: fourthLineVoice,
    url: "https://open.spotify.com/show/7xHZABwcd1L4aqWAFs5rAp",
  },
  {
    name: "Five for Fighting",
    image: fiveForFighting,
    url: "https://open.spotify.com/show/4OJAh0gyEIBAl5BKjI1vsN",
  },
];

export const Footer = () => {
  return (
    <footer className="bg-flyers-black border-t border-flyers-dark-gray">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex flex-col items-center gap-4">
          <h1 className="font-heading text-xl font-black uppercase tracking-wide text-flyers-white">
            Hockey Fight <span className="text-flyers-orange">Chronicles</span>
          </h1>
          <div className="w-12 border-t-2 border-flyers-orange" />
          {/* Friends */}
          <div className="flex flex-col items-center gap-2">
            <span className="text-flyers-mid-gray text-xs uppercase tracking-widest">
              Friends
            </span>
            <div className="flex items-center gap-6">
              {friends.map((friend) => (
                <a
                  key={friend.name}
                  href={friend.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex flex-col items-center gap-1 group"
                >
                  <img
                    src={friend.image}
                    alt={friend.name}
                    className="w-[52px] h-[52px] rounded-full object-cover border-2 border-flyers-dark-gray group-hover:border-flyers-orange transition-colors duration-200"
                  />
                  <span className="text-flyers-mid-gray text-xs">
                    {friend.name}
                  </span>
                </a>
              ))}
            </div>
          </div>
          <p className="text-flyers-mid-gray text-sm">
            &copy; {new Date().getFullYear()} Hockey Fight Chronicles. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
